// The program-details endpoint returns one resolved fee entry per active
// course: { course_id, custom_fee, default_fee, course_fee,
// branch_course_fee_id, source }. Bulk upload enrolls into the program's
// (single) course, so pick that course's entry.
//
// Enrollment needs a price (course_fee); a missing one is reported as
// `problem` and processing must not start. branch_course_fee_id (the branch's
// School Program default row) is provenance only and may be null when the
// program has a custom fee but the branch has no default row: /process
// accepts a null branchCourseFeeId.
export const getProgramCourseFee = (programDetails) => {
  const course = programDetails?.courses?.[0];
  const fee = course
    ? (programDetails.fees || []).find((f) => f.course_id == course.course_id)
    : undefined;

  let problem = null;
  if (!course) {
    problem = "This program has no active course to enroll students into.";
  } else if (!fee || fee.course_fee == null) {
    problem = `No fee is set for ${course.course_name}: the branch has no School Program default fee and this program has no custom fee. Add a default under Branch Courses > Course Fees, or a custom fee on the program, before uploading.`;
  }

  return { course, fee, problem };
};
